import { Box, styled } from "@mui/material";

import { c } from "@/federal-ci/theme";

export const FooterSection = styled(Box)({
  color: c.monochrome[50],
});
